import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "liquid-button text-primary-foreground rounded-xl shadow-liquid-md hover:shadow-liquid-lg",
        destructive:
          "bg-gradient-to-br from-destructive/95 to-destructive/90 text-destructive-foreground rounded-xl shadow-lg backdrop-blur-sm border border-destructive/40 hover:shadow-xl hover:scale-[1.02] active:scale-[0.98]",
        outline:
          "glass rounded-xl border-border/50 hover:border-primary/40 hover:bg-primary/5 shadow-liquid-sm hover:shadow-liquid-md",
        secondary:
          "bg-gradient-to-br from-secondary/95 to-secondary/90 text-secondary-foreground rounded-xl shadow-lg backdrop-blur-sm border border-secondary/40 hover:shadow-xl hover:scale-[1.02] active:scale-[0.98]",
        ghost: "rounded-xl hover:glass hover:shadow-liquid-sm",
        link: "text-primary underline-offset-4 hover:underline rounded-lg",
      },
      size: {
        default: "h-10 px-5 py-2.5",
        sm: "h-9 rounded-lg px-4 text-xs",
        lg: "h-12 rounded-xl px-8 text-base",
        icon: "h-10 w-10 rounded-xl",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
